import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getStaffPerformance } from '@/api/home';
import validate from '@zzzj/zzzj/src/validate/index';
import { json2excel } from '@/util/json2excel';
export default {
  name: 'performance',
  computed: {
    searchQuery: function searchQuery() {
      var key = [];
      if (Array.isArray(this.model.daterange) && this.model.daterange.length === 2) {
        key.push("date>=\"".concat(this.$options.filters.date(this.model.daterange[0], 'yyyy-MM-dd'), "\" and date<=\"").concat(this.$options.filters.date(this.model.daterange[1], 'yyyy-MM-dd'), "\""));
      }
      if (this.model.staff) {
        key.push("name == \"".concat(this.model.staff, "\""));
      }
      if (this.model.receiving) {
        key.push("receiving ".concat(this.model.type, " ").concat(this.model.receiving));
      }
      return key.join(' and ');
    }
  },
  data: function data() {
    var validateReceiving = function validateReceiving(rule, value, callback) {
      if (value !== undefined && value !== '') {
        if (validate.isNum(value)) {
          return callback();
        } else {
          return callback(new Error('请输入正确的数字'));
        }
      }
      return callback();
    };
    return {
      model: {
        daterange: [],
        receiving: undefined,
        staff: undefined,
        type: '>',
        tableType: 1
      },
      tableData: [],
      loading: false,
      rules: {
        receiving: [{
          validator: validateReceiving,
          message: '请输入正确的数字',
          trigger: 'change'
        }]
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  methods: {
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _this.tableData = [];
              _context.n = 1;
              return _this.$awaitTo(getStaffPerformance({
                pagesize: 9999,
                searchQuery: _this.searchQuery,
                groupby: _this.model.tableType === 2 || _this.model.tableType === 3 ? 'name' : undefined,
                select: _this.model.tableType === 3 ? 'new(Key,sum(receiving) as sum)' : undefined
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (Array.isArray(data)) {
                if (_this.model.tableType === 1) {
                  _this.tableData = data.map(function (item) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                      _date: _this.$options.filters.date(item.date, 'yyyy-MM-dd')
                    });
                  });
                } else if (_this.model.tableType === 2) {
                  _this.tableData = data.map(function (item) {
                    var first = item[0].date;
                    var end = item[item.length - 1].date;
                    return {
                      first: first,
                      end: end,
                      name: item[0].name,
                      data: item
                    };
                  });
                } else if (_this.model.tableType === 3) {
                  _this.tableData = data;
                }
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
        data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 1) {
          sums[index] = 'N/A';
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ' 份';
        }
      });
      return sums;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$checkForm();
            case 1:
              _this2.getList();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    export2Excel: function export2Excel() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var name, excelHeader, data, line, i, sum, footer, excelData;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              name = '收发函绩效.xlsx';
              excelHeader = _this3.model.tableType === 1 ? [['回函处理日期', '处理人', '处理份数']] : [['姓名', '总数']];
              data = _this3.model.tableType === 1 ? _this3.tableData.map(function (item) {
                return [item._date, item.name, item.receiving];
              }) : _this3.tableData.map(function (item) {
                return [item.Key, item.sum];
              });
              line = [];
              for (i = 0; i < excelHeader[0].length - 2; i++) {
                line.push('');
              }
              sum = 0;
              if (_this3.model.tableType === 1) {
                sum = _this3.tableData.reduce(function (a, b) {
                  return a + b.receiving;
                }, 0);
              } else {
                sum = _this3.tableData.reduce(function (a, b) {
                  return a + b.sum;
                }, 0);
              }
              footer = [['合计'].concat(line, [sum])];
              excelData = [].concat(excelHeader, _toConsumableArray(data), footer);
              json2excel(excelData, name);
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    this.getList();
  }
};